import portalRoutes from './portalRoutes';

let updatedRoutes = portalRoutes;
const routes = [...updatedRoutes];

export default routes;
